export const DEFERRED = 'Deferred';
export const MONTHLY = 'Monthly';
export const SBA = 'SBA';
export const SBA_DECISION_STAGES = ['Declined', 'Forgiven', 'SBA Response Received'];
export const PPP20 = '20PPPLoan';
export const PPP21 = '21PPPLoan';
